import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "../data/siteData";

const FloatingWhatsApp = () => (
  <a
    href={WHATSAPP_URL}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="floating-whatsapp-btn"
    aria-label="Falar no WhatsApp da Soccer Trainer"
    className="fixed bottom-5 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-lawn text-navy shadow-[0_8px_30px_rgba(141,198,63,0.45)] transition-transform duration-200 hover:scale-110"
  >
    <span
      className="absolute inset-0 rounded-full bg-lawn"
      style={{ animation: "pulse-ring 2.2s ease-out infinite" }}
      aria-hidden="true"
    />
    <MessageCircle size={26} strokeWidth={2.4} className="relative" />
  </a>
);

export default FloatingWhatsApp;
